import React, { useEffect, useState } from "react";
import { ShowMoreBtn } from "../../atoms/show-more-btn";
import TimeStamp from "../../atoms/time-stamp";
import { Link } from "@quintype/components";
import useUrl from "../../../hook/useUrl";
import "./sidebar-list.m.css";
import { CommentIcon } from "../../molecules/comment-icon";

const SidebarList = ({paakirjoitus=false,kolumnit=false, sports=false, yleisolta=false}) => {
  const [loadMore, setLoadMore] = useState(5);
  const [editorialCategory, setEditorialCategory] = useState([]);
  var [showBtn, setShowBtn] = useState(true);
  const [,currentUrlSlug] = useUrl();
  useEffect(() => {
    let collectionSlug=""
    let currentUrl=""
    let currentPage=""
    if (typeof window === "undefined") {
      console.log("Oops, `window` is not defined")
    } else {
      const decodeURI = decodeURIComponent(window.location.href);
      currentUrl = decodeURI.split('/')[3];
      if (window.location.href.indexOf("yhteissivusto") > -1) {
        currentPage = "yhteissivusto";
      }  else {
        currentPage = "ilkka-pohjalainen";
      }
      if(currentUrl==="vaasalehti"){
        if(paakirjoitus){
          collectionSlug=`paakirjoitus-vaasalehti-${currentPage}`;
        }else if(kolumnit){
          collectionSlug=`kolumnit-vaasalehti-${currentPage}`;
        }else if(sports){
          collectionSlug=`kentan-laidalta-vaasalehti-${currentPage}`;
        }

      }else if(currentUrl==="epari"){
        if(paakirjoitus){
          collectionSlug=`paakirjoitus-epari-${currentPage}`;
        }else if(kolumnit){
          collectionSlug=`kolumnit-epari-${currentPage}`;
        }else if(yleisolta){
          collectionSlug=`yleisolta-epari-${currentPage}`;
        }

      }
    }
    async function fetchAPI() {
      await fetch(`/api/v1/collections/${collectionSlug}`)
        .then((res) => res.json())
        .then((json) => setEditorialCategory(json.items))
    }
    fetchAPI();
  }, [])

  const editorialTopics = [...editorialCategory || []];
  const handleLoadMore = () => {
    setLoadMore(loadMore + 5);
    if (editorialCategory.length <= loadMore + 5) {
      setShowBtn(false)
    }
  }
  if (editorialTopics.length < 1) {
    return null;
  }
  let componentTitle="";
  if(paakirjoitus){
    componentTitle="PÄÄKIRJOITUKSET";
  }else if(kolumnit){
    componentTitle="KOLUMNIT";
  }else if(sports){
    componentTitle="KENTÄN LAIDALTA";
  }else if(yleisolta){
    componentTitle="YLEISÖLTÄ";
  }
  return (
    <React.Fragment>
      <div styleName="sidebar-global">
        <h2 className="top-headline" styleName="top-headline">{componentTitle}</h2>
          {editorialTopics
            .slice(0, loadMore)
            .map((item, index) => {
              const paaaihe = item.story.metadata["pääaihe"];
              return (
                <React.Fragment key={index}>
                  <Link href={`/${currentUrlSlug}/${item.story.slug}`} styleName="wrapper" className="wrapper-newest-category" key={index}>
                    <h2 styleName="headline" className="main-headline">
                        <span styleName="span-newest">{paaaihe && `${paaaihe} | `}</span>
                        {item.story.headline}
                    </h2>
                    <div styleName="section-time-wrapper" className="section-time-wrapper">
                        <TimeStamp timeStamp={item.story["published-at"]} />
                        <CommentIcon storyObj={item.story} />
                    </div>
                  </Link>
                </React.Fragment>
              );
            })}
          {(showBtn===true && editorialCategory.length > 5) &&
            <ShowMoreBtn loadMore={handleLoadMore} btnName="NÄYTÄ LISÄÄ" />
          }
      </div>
    </React.Fragment>
  );
};

export default SidebarList;
